import AuthSignUpCreatorTabComponent from "./AuthSignUpCreatorTabComponent";

export default AuthSignUpCreatorTabComponent;
